const doc = [({"zh_tw":({"adminConstantHotelFilterType":({"meal":"餐點", "planOption":"方案選項", "roomAmenity":"客房設施", "roomProperty":"客房設備"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;